import { OtpContextEnum } from "../../../common/network/enum";
import { createCandidate } from "../../network/network";
import { handlerError } from "../otp-verification-screen/handle-otp-error";

export const createCandidateFunc = async (props: {
  username: string;
  password: string;
  context: OtpContextEnum;
  otp: string;
  lang: string; //PHKL Custom
  invitationId?: string; //PHKL Custom
  userId?: string; //PHKL Custom
}): Promise<any> => {
  const { username, password, context, otp, lang /*PHKL Custom */, invitationId /*PHKL Custom */, userId /*PHKL Custom */ } =
    props;
  try {
    const res = await createCandidate({
      username: username,
      password: password,
      context: context,
      otp: otp,
      lang: lang, //PHKL Custom
      invitationId: invitationId, //PHKL Custom
      userId: userId, //PHKL Custom
    });
    //PHKL Custom -s
    const msg = handlerError(res);
    return { ok: !!msg, data: res?.data, msg: msg };
    //PHKL Custom -e
  } catch (e) {
    //PHKL Custom -s
    const msg = handlerError(e);
    return { ok: false, msg: msg };
    //PHKL Custom -e
  }
};
